import { render, staticRenderFns } from "./UserRoleChip.vue?vue&type=template&id=c88a1fce&"
import script from "./UserRoleChip.vue?vue&type=script&lang=js&"
export * from "./UserRoleChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports